module.exports = __webpack_public_path__ + "static/media/AB_O1_13.a228edc2.jpg";